'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _map2 = require('lodash/map');

var _map3 = _interopRequireDefault(_map2);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _capeStyle = require('cape-style');

var _capeStyle2 = _interopRequireDefault(_capeStyle);

var _image = require('../image');

var _capeField = require('../capeField');

var _Field = require('./Field');

var _Field2 = _interopRequireDefault(_Field);

var _FileSelectContainer = require('../FileUpload/FileSelectContainer');

var _FileSelectContainer2 = _interopRequireDefault(_FileSelectContainer);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function Fields(props) {
  var entity = props.entity,
      fields = props.fields,
      title = props.title;
  var prefix = (0, _capeField.getEntityPrefix)(props); // console.log(entity)

  return _react2.default.createElement('div', {
    className: 'fields'
  }, title && _react2.default.createElement('h2', null, title), _react2.default.createElement('ul', {
    style: (0, _capeStyle2.default)('lsNone m0 p0')
  }, (0, _map3.default)(fields, function (_ref) {
    var id = _ref.id,
        field = _objectWithoutProperties(_ref, ['id']);

    return _react2.default.createElement('li', {
      key: id
    }, field.type === 'file' && _react2.default.createElement(_FileSelectContainer2.default, _extends({}, field, {
      collectionId: field.collectionId,
      initialValue: entity[id],
      fieldId: id,
      subject: entity,
      onSelect: _image.handleSelect
    })), field.type !== 'file' && _react2.default.createElement(_Field2.default, _extends({}, field, {
      id: id,
      initialValue: entity[id],
      prefix: prefix
    })));
  }), _react2.default.createElement('li', {
    className: 'id-field'
  }, entity.id)));
}

Fields.propTypes = {
  // dispatch: PropTypes.func,
  entity: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired
  }).isRequired,
  fields: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]).isRequired,
  // prefix: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: _propTypes2.default.string.isRequired
};
Fields.defaultProps = {
  title: 'Edit Entity'
};
exports.default = Fields;
module.exports = exports['default'];